import { render, staticRenderFns } from "./userauth.vue?vue&type=template&id=0fa5c24d&scoped=true&"
import script from "./userauth.vue?vue&type=script&lang=js&"
export * from "./userauth.vue?vue&type=script&lang=js&"
import style0 from "./userauth.vue?vue&type=style&index=0&id=0fa5c24d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa5c24d",
  null
  
)

export default component.exports